import React from 'react';
import './style.scss';

export default props => {
    return <div className={`zt-panel ${props.className}`} >
         {props.children?.map((element, key) => React.cloneElement(element, {key, onClose: () => props.onClose && props.onClose(false)}))}
    </div>
}